import { Divider, Row, Upload } from "antd";
import styled from "styled-components";

export const StyledBookingSectionHeader = styled.div`
  position: relative;
  background-color: rgba(181, 192, 218, 0.3);
  color: var(--text-black);
  font-weight: 500;
  min-height: 40px;
  padding: 0px 15px;
  display: flex;
  align-items: center;
  font-size: 16px;
`;

export const StyledBookingsDetails = styled.div`
  .action-header-row {
    padding: 10px 0;
  }
  min-height: 530px;
  .action-bar{
   position: sticky;
  top: 0;
  z-index: 1;
   background-color:var(--accent);
   padding: 5px;
  }
`;
export const StyledBookingsDivider = styled(Divider)``;
export const BookingsSectionTitle = styled.h6`
  position: relative;
  margin: 30px 0 15px 0;
  line-height: 20px;
  color: var(--text-black);
  font-weight: 600;
  text-transform: uppercase;

  & span {
    background-color: white;
    padding: 0 15px;
    margin-left: 20px;
    display: inline-block;
    position: relative;
    z-index: 1;
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    /*right: 0;*/
    width: 100%;
    height: 2px;
    z-index: 0;
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

export const StyledUploadFile = styled.div`
  .custom-upload-full {
    .ant-upload.ant-upload-select {
      width: 100%;
      height: auto;
      min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      .ant-image-img {
        max-height: 200px;
      }
      .ant-upload {
        width: 100%;
        height: 100%;
        max-height: 320px;
      }
    }
  }
`;
export const StyledActionPreview = styled.div`
  .action-pagination {
    color: var(--text-black);
    text-align: center;
    margin-bottom: 10px;
  }
  button {
    font-size: 20px;
    width: 16px;
    padding: 0px;
    color: var(--text-blue-dark);
  }
`;
export const StyledFlagInformation = styled.div`
   padding:5px 0px;
  .info-label {
    font-size: 16px;
    font-weight: 700;
    color: var(--label-color-primary);
    margin-bottom: 5px;
  }
  .info-value {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 15px;
    color:var(--text-black)
  }
`;

export const StyledJacketDetailsModalInfo = styled.div`
  .Jacket-Modal-Info {
    width: 100%;
    padding: 16px;
    background-color: var(--teal-blue-200);
    color: var(--background-color);
  }
`;
